module.exports = __webpack_public_path__ + "files/83cf86a4cd2fe316a6ce5000e75fec47.png";